import { Col, Row } from 'react-bootstrap';
import emptyPlaceholder from '../../assets/images/empty-placeholder.png';

interface IProps {
  className?: string;
}

const EmptyPlaceholder = (props: IProps) => {
  return (
    <Row>
      <Col className={['text-center', props.className].join(' ')}>
        <img className='img-fluid' src={emptyPlaceholder} alt='empty' />
      </Col>
    </Row>
  );
};

export default EmptyPlaceholder;
